import { render, staticRenderFns } from "./WorkOrderDetailTable.vue?vue&type=template&id=abfb51cc&scoped=true&"
import script from "./WorkOrderDetailTable.vue?vue&type=script&lang=js&"
export * from "./WorkOrderDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderDetailTable.vue?vue&type=style&index=0&id=abfb51cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfb51cc",
  null
  
)

export default component.exports